import { sample } from 'effector';
import { debounce, delay } from 'patronum';
import { AlertProps } from '@mui/material';
import { MOUNT_DELAY } from '@consts/delay';
import { signout } from '@features/common';
import i18n from '@shared/config/i18n';
import { processStatuses } from '../../types';
import { setToastData } from '../toast/model';
import {
  $notReadImports,
  $openImportsPopperCounter,
  CHECK_NOT_READ_STATUS_TIMEOUT,
  fxImportInterrupt,
  fxImportReadNotification,
  fxImportsCheckNotReadStatus,
  fxImportsCheckNotReadStatusManualy,
  importInterrupt,
  importReadNotification,
  importsCheckNotReadStatus,
  ImportTemporalGate,
} from './model';

const { t } = i18n;

$openImportsPopperCounter
  .on(fxImportsCheckNotReadStatusManualy.done, (state) => state + 1)
  .reset(signout);

$notReadImports
  .on(fxImportsCheckNotReadStatus.doneData, (_, { processes }) => processes)
  .on(fxImportsCheckNotReadStatusManualy.doneData, (_, { processes }) => processes)
  .reset(signout);

/** Проверяю наличие активных импортов после запроса и, если есть, то запускаю событие через TIMEOUT */
const isActiveImport = sample({
  clock: debounce({
    source: fxImportsCheckNotReadStatus.doneData,
    timeout: CHECK_NOT_READ_STATUS_TIMEOUT,
  }),
  filter: ({ processes }) =>
    !!processes.filter(({ status }) => status === processStatuses.processing).length,
});
/** Проверяю наличие активных импортов после ручного запроса (отправки файла на импорт) и, если есть, то запускаю событие через TIMEOUT */
const isActiveManualyImport = sample({
  clock: debounce({
    source: fxImportsCheckNotReadStatusManualy.doneData,
    timeout: CHECK_NOT_READ_STATUS_TIMEOUT,
  }),
  filter: ({ processes }) =>
    !!processes.filter(({ status }) => status === processStatuses.processing).length,
});

/** Стартую проверку активных импортов при загрузке и после получения этих же данных с импортами в обработке */
const delayedOpen = delay({
  source: ImportTemporalGate.open,
  timeout: MOUNT_DELAY,
});

sample({
  clock: [
    delayedOpen,
    isActiveImport,
    isActiveManualyImport,
    fxImportInterrupt.done,
    fxImportReadNotification.done,
  ],
  target: fxImportsCheckNotReadStatus,
});
/** Стартую проверку активных импортов */
sample({
  clock: importsCheckNotReadStatus,
  target: fxImportsCheckNotReadStatusManualy,
});

/** Прерываю импорт */
sample({
  clock: importInterrupt,
  fn: (process_id) => ({ process_id }),
  target: fxImportInterrupt,
});

/** Отправляю запрос, что импорты прочтены */
sample({
  clock: importReadNotification,
  fn: (process_ids) => ({ process_ids }),
  target: fxImportReadNotification,
});

sample({
  clock: [
    fxImportsCheckNotReadStatusManualy.fail,
    fxImportsCheckNotReadStatus.fail,
    fxImportInterrupt.fail,
    fxImportReadNotification.fail,
  ],
  fn: ({ error }) => ({
    visible: true,
    type: 'error' as AlertProps['severity'],
    text: error?.message ?? t('UnexpectedError'),
    autoHideTimerMs: 5000,
  }),
  target: setToastData,
});
